<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ title }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRef">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.header')}}</label>
              <el-form-item prop="companies">
                  <el-select class="w-full" 
                    v-model="form.clients" 
                    multiple 
                    filterable 
                    :disabled="isLoadingSelect" 
                    @visible-change="onExpand" 
                    @change="onChangeInput">
                    <el-option
                      v-for="item in clients"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                  </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button 
          mode="secondary-phantom-blue"
          class="w-full"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="handleSelectAll" 
          :loading="isLoadingSelect"
          />
        <base-button 
          v-else 
          :text="$t('app.unselect_all')" 
          mode="secondary-phantom-blue"
          class="w-full"
          @click="handleUnSelectAll"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
          <div class="w-48 "></div>
        <base-button 
          @click="toggleDialog" 
          mode="secondary-phantom-blue" 
          :text="$t('app.cancel')" 
          class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button 
          mode="secondary-phantom-blue" 
          class="w-full" 
          :text="$t('app.accept')" 
          @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import { getClients } from '@/services/clients/getClients'

export default
{
  name: 'template-link-clients-dialog',
  props: {
    title: {
      type: String,
      default: 'Título'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    distributorId: {
      type: [Number, String],
      default: -1
    },
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        clients: []
      },
      clients: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      if (!value) this.form.clients = []
    },
  },
  mounted: async function () {
    this.isLoadedData = false
    let params = null
    if (this.distributorId !== -1 && this.distributorId !== '-1') {
      params = { idDistribuidor: this.distributorId }
    }
    const data = await getClients(params)
    if (data.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
    } else {
      data.Clientes.forEach(row => {
        this.clients.push({ id: row.idCliente, label: row.Nombre })
      })
    }
    this.isLoadedData = true
  },
  computed: {
    isEmptyList: function () {
      return this.clients === undefined || this.clients === null || this.clients.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.clients.length === this.form.clients.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    changeSelectedCompanies (clients) {
      this.form.clients = clients
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      // this.form.clients = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.clients)
      // this.form.clients = []
    },
    handleSelectAll: async function () {
      // this.form.location = []
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.clients.forEach(element => {
        setTimeout(() => {
          this.form.clients.push(element.id)
          if (this.form.clients.length === this.clients.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.clients.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.clients.pop()
          if (this.form.clients.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
